export default {
  jobListingTasks: [],
  jobListingTask: undefined,
};
